import { Instagram, Facebook, Mail, MessageCircle, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "../constants";

const CONTACT_EMAIL = "perasciano@gmail.com";

const COLUMNS = [
  {
    title: "L'associazione",
    links: [
      { to: "/chi-siamo", label: "Chi siamo" },
      { to: "/trasparenza", label: "Trasparenza · Statuto" },
      { to: "/progetti", label: "Progetti" },
      { to: "/faq", label: "Domande frequenti" },
    ],
  },
  {
    title: "Partecipa",
    links: [
      { to: "/partecipa", label: "Diventa volontario" },
      { to: "/associarsi", label: "Diventa socio (gratis)" },
      { to: "/dona", label: "Dona" },
      { to: "/segnalazioni", label: "Segnalazioni" },
      { to: "/monte-faeta", label: "Firma Monte Faeta" },
    ],
  },
  {
    title: "Iniziative",
    links: [
      { to: "/news", label: "News" },
      { to: "/eventi", label: "Eventi" },
      { to: "/riunione", label: "Prima Riunione" },
      { to: "/cosa-facciamo", label: "Cosa facciamo" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-[#1f2d22] text-white pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 pb-10 border-b border-white/15">
          {/* Brand col */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src="/logo-per-asciano-white.png" alt="Per Asciano logo" className="h-12 w-auto" />
              <div className="leading-tight">
                <div className="font-display text-base font-black tracking-[0.18em] uppercase">Per Asciano</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/65 mt-0.5">Associazione territoriale</div>
              </div>
            </Link>
            <p className="text-sm text-white/70 leading-relaxed max-w-xs mb-4">
              Cittadini per la tutela e la valorizzazione del territorio di
              Asciano e del Monte Faeta.
            </p>
            <div className="text-xs text-white/55 space-y-1">
              <div>Asciano (PI) · Toscana</div>
              <div>
                <span className="font-semibold text-white/75">C.F.</span> 93104860502
              </div>
            </div>
            <div className="mt-5 flex items-center gap-3">
              <a href="https://www.instagram.com/perasciano/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/perasciano" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-bacheca" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {COLUMNS.map((c) => (
            <div key={c.title}>
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-[#E8C9A0] mb-4">{c.title}</div>
              <ul className="space-y-2.5 text-sm text-white/85">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="hover:text-white inline-flex items-center gap-1.5">
                      {l.to === "/trasparenza" && <FileText className="w-3 h-3" />}
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Associazione Per Asciano · C.F. 93104860502</div>
          <div className="flex items-center gap-4">
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="hover:text-white inline-flex items-center gap-1.5">
              <Mail className="w-3.5 h-3.5" />
              {CONTACT_EMAIL}
            </a>
            <Link to="/contatti" className="hover:text-white">Contatti</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
